module.exports = __webpack_public_path__ + "img/dpi-logo.ec374279.png";